import { h as __h } from "preact";
import { signal } from "@preact/signals";
/** @import { Signal } from "@preact/signals"; */
import { Component, h } from "preact";
import { adminMachineResponse } from "~/backend/validate.js";
import { ApiError, authedApiRequest, paginatedResponse, query } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
/** @import { Placement } from "~/util/float.js"; */
import { popover } from "~/util/popover.js";
import Query from "~/util/query.js";
import Button from "~/component/Button.js";
import Icon from "~/component/Icon.js";
import Combobox from "~/admin/component/Combobox.js";
/** @import { Option } from "~/admin/component/Combobox.js"; */

import adminStyle from "~/admin/lib/style.js";
import util from "~/style/util.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./addComputers.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./addComputers.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @param {{
 * 	anchor: HTMLButtonElement;
 * 	orgId: string;
 * 	groupId: string;
 * 	placement: Placement;
 * }} props
 */
export const addComputers = async ({
  anchor,
  orgId,
  groupId,
  placement
}) => {
  const machine_ids = await popover({
    anchor,
    placement,
    content: (/** @type {(result?: string[]) => void} */resolve) => h(PopoverChildren, {
      resolve,
      orgId
    })
  });
  if (!machine_ids?.length) return;
  try {
    await authedApiRequest("PUT", `/v2/orgs/${orgId}/machines/assign`, {
      json: {
        machine_ids,
        group_id: groupId,
        user_id: ""
      }
    });
    Query.invalidate([`/ui/admin/orgs/${orgId}/machines`], ...machine_ids.map(id => [`/ui/admin/orgs/${orgId}/machines/${id}`]), [`/ui/admin/orgs/${orgId}/members`], [`/v2/orgs/${orgId}/groups`], [`/v2/orgs/${orgId}/groups/${groupId}`]);
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};

/**
 * @extends {Component<PopoverChildrenProps>}
 *
 * @typedef {object} PopoverChildrenProps
 * @property {string} orgId
 * @property {(result?: string[]) => void} resolve
 */
class PopoverChildren extends Component {
  query = signal("");
  /** @type {Signal<Map<string, Option>>} */
  selected = signal(new Map());
  machines = query(() => ({
    key: [`/ui/admin/orgs/${this.props.orgId}/machines`, {
      limit: 5,
      q: this.query.value
    }],
    keepPreviousData: true
  }), {
    schema: paginatedResponse(adminMachineResponse)
  });
  render() {
    return __h("div", {
      "class": css.popover
    }, h(Combobox, {
      query: this.query,
      debounce: 200,
      loading: this.machines.loading,
      multiSelected: this.selected,
      options: this.machines.data?.data.map(machine => ({
        id: machine.id,
        label: machine.name,
        render: () => __h("div", {
          "class": css.machine
        }, __h(Icon, {
          name: "machine",
          size: 14
        }), __h("div", {
          "class": css.text + " " + util.truncate
        }, machine.name))
      }))
    }), __h("div", {
      "class": adminStyle.actions
    }, __h(Button, {
      level: "primary",
      disabled: this.selected.value.size === 0,
      onClick: () => this.props.resolve([...this.selected.value.keys()])
    }, "Add computers"), __h(Button, {
      onClick: () => this.props.resolve()
    }, "Cancel")));
  }
}